
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync } from 'vue-property-decorator';
	import PrescriptionItem from '@/components/new-prescription/prescription-items/PrescriptionItem.vue';
	import PrescriptionItemWrapper from '@/components/new-prescription/prescription-items/PrescriptionItemWrapper.vue';

	@Observer
	@Component({
		components: { PrescriptionItemWrapper }
	})
	export default class PrescriptionItemCheckbox extends PrescriptionItem {
		@PropSync('inputCheckboxLeft', { required: true }) inputCheckboxLValue!: any[];
		@PropSync('inputCheckboxRight', { required: true }) inputCheckboxRValue!: any[];
		@Prop({ required: true }) checkbox!: any[];
	}
